module.exports = __webpack_public_path__ + "img/swap_vert.dd3bfa12.svg";